import cx from 'classnames';
import { forwardRef } from 'react';

import { ConditionalView } from '../../utils/ConditionalView';
import { WrapTextNodes } from '../../utils/WrapTextNodes';
import Icon from '../Icon';
import styles from './Checkbox.module.scss';
import usePresenter from './Checkbox.presenter';
import type { CheckboxProps } from './Checkbox.types';

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>((props: CheckboxProps, ref) => {
  const {
    labelAlignment,
    disabled,
    isChecked,
    required,
    name,
    invalid,
    variantProps,
    otherInputProps,
    onCheckboxChanged,
  } = usePresenter(props);

  return (
    <label
      className={cx(
        styles.checkbox,
        props.className,
        {
          [styles.labelLeft]: labelAlignment === 'Left',
          [styles.labelRight]: labelAlignment === 'Right',
          [styles.disabled]: disabled,
        },
      )}
      {...variantProps}
    >
      <input
        {...otherInputProps}
        type="checkbox"
        className={styles.input}
        checked={isChecked}
        onChange={onCheckboxChanged}
        disabled={disabled}
        required={required}
        ref={ref}
        name={name}
        value={name}
        aria-invalid={invalid}
        id={props.id}
      />
      <div className={styles.iconWrapper}>
        <div className={styles.iconContainer}>
          <Icon icon="Check" style="Filled" className={cx(styles.icon)} />
        </div>
      </div>
      <ConditionalView condition={props.children}>
        <WrapTextNodes className={styles.label}>
          {props.children}
        </WrapTextNodes>
      </ConditionalView>
    </label>
  );
});

export default Checkbox;
